import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export interface BlogPost {
  slug: string;
  title: string;
  excerpt: string;
  date: string;
  readTime: string;
  category: string;
  image?: string;
}

const snapTransition = {
  type: "tween" as const,
  ease: [0.2, 0.8, 0.2, 1] as [number, number, number, number],
  duration: 0.4,
};

export function ArticleCard({ post, index }: { post: BlogPost; index: number }) {
  return (
    <motion.article
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ ...snapTransition, delay: index * 0.1 }}
      whileHover={{ y: -4 }}
      className="group relative flex flex-col surface-card snap-transition hover:border-primary/60 overflow-hidden"
    >
      {post.image && (
        <div className="aspect-[16/9] overflow-hidden">
          <img
            src={post.image}
            alt={post.title}
            className="w-full h-full object-cover group-hover:scale-105 snap-transition"
            loading="lazy"
          />
        </div>
      )}
      <div className="flex flex-col gap-3 p-6 flex-1">
        <div className="flex items-center gap-3">
          <span className="text-xs font-body font-bold uppercase tracking-widest text-primary">{post.category}</span>
          <span className="text-xs text-muted-foreground">•</span>
          <time className="text-xs font-mono uppercase tracking-widest text-muted-foreground">{post.date}</time>
        </div>
        <h3 className="font-display text-2xl leading-tight text-balance group-hover:text-primary snap-transition">
          {post.title}
        </h3>
        <p className="text-muted-foreground font-body text-sm line-clamp-2 text-pretty leading-relaxed">{post.excerpt}</p>
        <div className="mt-auto pt-4 border-t border-border flex items-center justify-between">
          <span className="text-sm font-body font-bold uppercase tracking-tight">Read Analysis</span>
          <div className="flex items-center gap-2">
            <span className="text-xs text-muted-foreground font-body">{post.readTime}</span>
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 snap-transition text-primary" />
          </div>
        </div>
      </div>
      <Link to={`/blog/${post.slug}`} className="absolute inset-0" />
    </motion.article>
  );
}
